import { logoutApi } from "@/api/services/main/auth";
import { removeAxiosAuth } from "@/utils/api";
import { getSessionIdentity, getToken, removeToken } from "@/utils/token";

/**
 * Clears the current session: removes the access/refresh tokens and the Axios
 * auth headers.
 *
 * Returns the email + externalId (組織ID) of the session being cleared (read from
 * the access token claims before it is removed) so callers can send the user back
 * to the login flow with the form pre-filled: `/login/credentials?externalId=...&email=...`
 * when an email is known, otherwise `/login?externalId=...`.
 */
export const logout = async (): Promise<{ email?: string; externalId?: string }> => {
  const { refreshToken } = getToken();
  if (refreshToken) await logoutApi({ refreshToken }).catch(() => 0);
  const { email, externalId } = getSessionIdentity();
  removeToken(); // clears token cookies + Axios Authorization header
  removeAxiosAuth();
  return { email, externalId };
};
